import { DETERMINAR_PAGINA_ATUAL_AGENCIA } from '../types'

export default function determinarPaginaAtualAgencia (paginaAtual) {
  return {
    type: DETERMINAR_PAGINA_ATUAL_AGENCIA,
    payload: paginaAtual
  }
}
